import create from 'zustand'
import { devtools, persist } from 'zustand/middleware'

export interface ScoreState {
  score: number,
  increaseScore: (newValue: number) => void
  resetScore: () => void,
  roomScoreId: string,
  setRoomScoreId: (newRoomId: string) => void,
  hazardsFound: string[],
  findHazard: (name: string) => void
  clearHazardList: () => void
  showDoneButton: boolean
}

export const useScoreStore = create<ScoreState>()(
  devtools(
    persist(
      (set) => ({
        score: 0,
        increaseScore: (newValue) => set((state) => ({ score: state.score + newValue })),
        resetScore: () => set(() => ({ score: 0 })),
        roomScoreId: '',
        setRoomScoreId: (newRoomId) => set(() => ({
          roomScoreId: newRoomId,
          hazardsFound: [],
          showDoneButton: false,
          score: 0
        })),
        hazardsFound: [],
        findHazard: (name) => set((state) => ({ hazardsFound: [...state.hazardsFound, name] })),
        clearHazardList: () => set({ hazardsFound: [] }),
        showDoneButton: false
      })),
    {
      name: 'score-storage'
    }
  )
)
